import React, { useContext } from 'react';
import Appbar from './Appbar';
import {Box} from '@mui/material';
import Home from './Home';
import AboutMe from './AboutMe';
import Projects from './../pages/Projects';
import Skills from './Skills';
import Education from '../pages/Education';
import Contactme from './ContactMe';
import useMediaQuery from '@mui/material/useMediaQuery';
import { DrawerContext } from '../contexts/DrawerContext';


const Layout = () => {
  const mediaMatch = useMediaQuery('(min-width:680px)');
  const {theme} = useContext(DrawerContext);
  return (
    <div style={{
      backgroundColor:theme.style.backgroundColor,
      color: theme.style.color
    }}>
        <Appbar/>
        {/* <DrawerComponent/> */}
        <Box sx={{width:mediaMatch?'85%':'100%',margin:'auto'}}>
          <div id='Home' >
            <Home/>
          </div>
          <div id='About Me' style={{backgroundColor:'#1976d2',color:'white'}}>
            <AboutMe/>
          </div>
          <div id='Skills' >
            <Skills/>
          </div>
          <div id='Projects' style={{backgroundColor:'#1976d2',color:'white'}}>
            <Projects/>
          </div>
          <div id='Education' >
            <Education/>
          </div>
          <div id='Socials' style={{backgroundColor:'#1976d2',color:'white'}}>
            <Contactme/>
          </div>
        </Box>
    </div>
  )
}

export default Layout